import React from "react";
import { findIcon } from "../../../../../dashboard/icons";
import { Card } from "react-bootstrap";

const LBLDocContainer = ({ title = "", documents = [] }) => {
  const handleDocumentClick = (docLink = "") => {
    window.open(docLink, "_blank");
  };
  const getFileType = (docLink = "") => {
    const extension = docLink?.split(".")?.pop()?.toLowerCase();
    const fileTypes = ["pdf", "doc"];
    const typeImg = ["png", "jpg", "jpeg", "webp"];

    return fileTypes.includes(extension)
      ? extension
      : typeImg.includes(extension)
      ? "image"
      : "default";
  };
  return (
    <Card>
      <Card.Header>
        <h6 className="">{title}</h6>
      </Card.Header>
      <Card.Body className="d-flex flex-wrap gap-3">
        {documents?.map((doc, index) => (
          <div
            key={index}
            className="d-flex align-items-center gap-3 p-3 pe-5 rounded-3 cursor-pointer"
            onClick={() => handleDocumentClick(doc?.url)}
            style={{ backgroundColor: "#f8f8f8" }}
          >
            <div className="flex-shrink-0">
              {getFileType(doc?.url) === "default" ? (
                findIcon("File Invoice", "outline", 60)
              ) : getFileType(doc?.url) === "image" ? (
                <img
                  src={doc?.url}
                  alt="LPL Document"
                  height={60}
                  width={"auto"}
                  className="rounded-3 object-cover"
                />
              ) : (
                findIcon(getFileType(doc?.url), "solid", 60)
              )}
            </div>
            <div className="text-black text-truncate">{doc.filename}</div>
          </div>
        ))}
      </Card.Body>
    </Card>
  );
};

export default LBLDocContainer;
